import { EventEmitter, Injectable, Output } from '@angular/core';
import { DetailedEntityDataService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { SearchParams } from '../../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../../shared/search/models/data-table-config';
import { SearchStatus } from '../../../../../shared/search/models/search-status.model';
import { SearchService } from '../../../../../shared/search/search.service';
import { SearchEvent } from '../../../../../shared/search/models/search-event';
import { REFRESH_SEARCH_EVENT, NEW_SEARCH_EVENT } from '../../../../../shared/search/search-constants';
import { PageDefinition } from '../../../../../shared/search/models/page-definition.model';

@Injectable()
export class CommodityDataService extends DetailedEntityDataService {

  public advanceConfigurationSearchService: SearchService;
  public skuAliasSearchService: SearchService;
  public upcNameArray: Array<any>;
  /* Below skuInfoExtendedFieldsSearchService added for LFWM-1904
  -used in CommoditySkuInfoAccordionComponent and in action-service save */
  public skuInfoExtendedFieldsSearchService: SearchService;
  @Output()
  valueChanged: EventEmitter<any> = new EventEmitter<any>();

  public getUpcNames(): any {
    return this.upcNameArray;
  }

  public setCurrentSearchService(type: any) {
    if (type === 'Advance Configuration') {
      this.searchService = this.advanceConfigurationSearchService;
    } else {
      this.searchService = this.skuAliasSearchService;
    }
  }
  public getSearchServiceForColumnGroup(columnGroup: string, tabIndex?: string) {
    if (columnGroup === 'Advance Configuration') {
      if (!this.advanceConfigurationSearchService) {
        this.advanceConfigurationSearchService = this.initializeSearchContext('skuconfigtd');
      }
      return this.advanceConfigurationSearchService;
    }
    if (columnGroup === 'SKU Alias/UPC') {
      if (!this.skuAliasSearchService) {
        this.skuAliasSearchService = this.initializeSearchContext('upctd');
      }
      return this.skuAliasSearchService;
    }
  }
  public initializeSearchContext(tableId: string) {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.idProperty = 'storerKey';
    searchParams.tableEditor = this.dataEditor;
    searchParams.isFullFetch = true;
    searchParams.alertService = this.alertService;
    if (this.buttonService && (tableId === 'skuconfigtd')) {
      searchParams.actionButtons = this.buttonService.getButtonsForPanel('advance-configuration');
    } else if (this.buttonService && (tableId === 'upctd')) {
      searchParams.actionButtons = this.buttonService.getButtonsForPanel('skuAlias/upc');
    } else if (this.buttonService && (tableId === 'ASSIGNLOCTD')) {
      searchParams.idProperty = 'location';
      searchParams.actionButtons = this.buttonService.getButtonsForPanel('assign-location');
    }
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.editable = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus = new SearchStatus();
    return this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
  }
  public handleAddNewItem(event, searchService: any) {
    this.searchService = searchService;
    const pageDefinition: PageDefinition = searchService.
      getPagedData().pageDefinition;
    // if the current table spans across multiple pages get the max value
    if (this.displayMode === 'E' && (pageDefinition.recordCount > pageDefinition.pageSize) && !this.maxIdValueForDetailTable) {
      searchService.getMaxValueForIdProperty().subscribe((response: any) => {
        if (response && response.propertyValues &&
          response.propertyValues.length > 0) {
          this.maxIdValueForDetailTable = response.propertyValues[0].cVal;
          this.initializeValuesForNewLine(event.selectedRow, searchService);
          searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        }
      });
    } else {
      this.initializeValuesForNewLine(event.selectedRow, searchService);
    }
    if (searchService.getPagedData().pageRows.length >=
      pageDefinition.pageSize) {
      // if the current page has overflown, clear the max value so that it can be refetched in the next page
      this.maxIdValueForDetailTable = null;
    }

    if (searchService.getPagedData().pageDefinition.recordCount === 1) {
      this.buttonService.initializeButtonsForPage(this.primaryDataMap, 'details');
    }
  }

  // this method initializes the value for a new line based on the search service passed
  public initializeValuesForNewLine(newRow, searchService) {
    let maxValue: string = '00000';
    const idProperty = searchService.searchParams.idProperty;
    searchService.getPagedData().pageRows.forEach((row: any) => {
      if (!maxValue || maxValue < row.cells[idProperty].cVal) {
        maxValue = row.cells[idProperty].cVal;
      }
    });

    if (this.maxIdValueForDetailTable && maxValue <
      this.maxIdValueForDetailTable) {
      maxValue = this.maxIdValueForDetailTable;
    }

    const newLineNumber = (+maxValue) + 1;
    let newLineNoStr = '' + newLineNumber;
    while (newLineNoStr.length < 5) {
      newLineNoStr = '0' + newLineNoStr;
    }
    newRow.cells[idProperty].cVal = newLineNoStr;
  }

  public reloadDetailTable(reInitializeButtons?: boolean) {
    this.searchService.performSearch();
    this.searchService.receiveEvent().subscribe((event: SearchEvent) => {
      if (event.type === NEW_SEARCH_EVENT) {
        const pageRows = this.searchService.getPagedData().pageRows;
        if (this.displayMode === 'E') {  // IN EDIT MODE
          this.dataEditor.populateAllRestrictedValues(pageRows);
        }
        if (reInitializeButtons) {
          this.buttonService.initializeButtons(this.primaryDataMap);
        }
      }
    });
  }
// LFWM-2883-make search table fields editable
  public overrideMetadataMapOfPrimaryTableFields(displayMode: any) { 
    if (displayMode === 'E') {
      const detailMetadata = this.getPrimarySearchService().getMetadata()['columnList'];
      for (let i = 0; i < detailMetadata.length; i++) {
        if (detailMetadata[i].propertyName === 'storerKey' || detailMetadata[i].propertyName === 'sku' ||  detailMetadata[i].propertyName === 'facility') {
          detailMetadata[i].displayType = 'V';
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/service/commodity-data.service.ts